export default __webpack_public_path__ + "static/media/Statistics_2005.f46b7516.zip";